import axios, { Method } from '@/apps/open/utils/axios'

export async function uploadImg (imgBase64Str: string, url: string, onUploadProgress: (progressEvent: any) => void) {
  return axios({ url, method: Method.Post, data: { data: imgBase64Str }, timeout: 120000, onUploadProgress })
}

export async function getLicenseUploadInfo () {
  return axios({ url: 'api/developer/license/upload_params', method: Method.Get })
}

export async function uploadLicense (url: string, formData: any) {
  return axios({ url, method: Method.Post, data: formData, headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: false, timeout: 60000 })
}
